module.exports = __webpack_public_path__ + "img/integration-not-found.951afe1d.svg";